import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AdminReferralPayment = {
  id: number;
  payerId: number;
  payerEmail: string;
  referrerId: number | null;
  referrerEmail: string | null;
  amount: number;
  commissionPercent: number;
  commissionAmount: number;
  note: string | null;
  createdAt: string;
};

export type AdminReferrerStats = {
  referrerId: number;
  referrerEmail: string;
  referralsCount: number;
  totalEarned: number;
  totalPaidOut: number;
  balance: number;
};

export type AdminReferralPayout = {
  id: number;
  referrerId: number;
  referrerEmail: string;
  amount: number;
  note: string | null;
  createdAt: string;
};

export type AdminPendingReferral = {
  userId: number;
  email: string;
  referrerId: number;
  referrerEmail: string;
};

export type AdminReferralsOverview = {
  referralPercent: number;
  totalPaid: number;
  totalCommission: number;
  totalPaidOut: number;
  referrers: AdminReferrerStats[];
  payouts: AdminReferralPayout[];
  payments: AdminReferralPayment[];
  pendingReferrals: AdminPendingReferral[];
};

const initialState: {
  overview?: AdminReferralsOverview;
  loading: boolean;
} = {
  overview: undefined,
  loading: false,
};

export const adminReferralsReducer = createSlice({
  name: 'adminReferrals',
  initialState,
  reducers: {
    loadAdminReferrals(state) {
      state.loading = true;
    },
    setAdminReferrals(state, action: PayloadAction<AdminReferralsOverview>) {
      state.overview = action.payload;
      state.loading = false;
    },
    adminReferralsFailed(state) {
      state.loading = false;
    },
    recordAdminPayment(
      _state,
      _action: PayloadAction<{
        payerEmail?: string;
        userId?: number;
        amount: number;
        commissionPercent?: number;
        referrerEmail?: string;
        note?: string;
      }>,
    ) {},
    updateReferralSettings(_state, _action: PayloadAction<number>) {},
    deleteAdminPayment(_state, _action: PayloadAction<number>) {},
    recordAdminPayout(
      _state,
      _action: PayloadAction<{
        referrerEmail?: string;
        referrerId?: number;
        amount: number;
        note?: string;
      }>,
    ) {},
    deleteAdminPayout(_state, _action: PayloadAction<number>) {},
  },
});

export const {
  loadAdminReferrals,
  setAdminReferrals,
  adminReferralsFailed,
  recordAdminPayment,
  updateReferralSettings,
  deleteAdminPayment,
  recordAdminPayout,
  deleteAdminPayout,
} = adminReferralsReducer.actions;
